<template>
	<div class='con_comment'>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="我的评论" goBack="true"></head-top>
		<!-- <div class="bg_a top_c flex_b color_e font_size_c fw ">
			<div class="comment_tab_item" :class="orderStatus==0?'active':''" @click="switchNav(0)">课程</div>
			<div class="comment_tab_item" :class="orderStatus==1?'active':''" @click="switchNav(1)">图书</div>
		</div> -->

		<!-- <div class='main_comment'> -->
		<div class="comment_list">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false" :finished-text="finishedText"
				 @load="onLoad" v-if="commentsList.length>0">
					<div v-for="(item, index) in commentsList" :key="index">
						<div class="comment_list_item bg_a">
							<!-- 已删除遮罩 delete：0未删除，1已删除，2过渡待删除-->
							<div class="comment_list_deleteMask flex_d" v-if="item.deleted==2">
								<img :src="require('../../assets/img/deleted.png')">
							</div>
							<!-- 状态角标 status=>1:待审核，2：通过，3：未通过-->
							<div class="comment_item_statusIcon">
								<img :src='require("../../assets/img/books/daish.png")' v-if="item.status==1">
								<img :src='require("../../assets/img/books/ysh.png")' v-if="item.status==2">
								<img :src='require("../../assets/img/books/shbtg.png")' v-if="item.status==3">
							</div>

							<!-- 头像，昵称，发表时间,删帖 -->
							<div class="flex_c comment_list_userinfo">
								<img :src='item.user.customAvatar?resourceDomain+item.user.customAvatar:default_avatar' class="comment_list_default_avatar">
								<div class="flex_c comment_list_userright">
									<div class="color_a font_size_c ellipsis_1" style="width:100%;">{{item.user.realName?item.user.realName:item.user.loginAccount}}</div>
									<div class="color_e font_size_b ellipsis_1" style="width:100%;">{{item.createTime}}</div>
								</div>
							</div>

							<!-- 图书 -->
							<div class="color_f font_size_b comment_list_book" @click="toBooksDetail(item.bookId)">
								<div class="ellipsis_2">{{item.bookName}}</div>
							</div>

							<!-- 评论-文字 -->
							<div class="color_a font_size_a comment_list_txt" @click="toCommentDetail(item.id,item.deleted)">
								<div v-html="item.comment?item.comment:'用户未填写评价'" class="ellipsis_4"></div>
							</div>

							<!-- 评论-多图 -->
							<div class="flex_a comment_list_imgs" v-if="item.imgs">
								<div v-for="(t,idx) in item.imgs.split(',')" :key='idx' class="comment_list_img_item">
									<img :src='resourceDomain+t' v-if="t" @click="previewImages(item.imgs.split(','),idx)"></img>
								</div>
							</div>

							<div class="flex_c font_size_b comment_list_btns" style="width: 100%;" v-if="item.canDelete||item.officialStatus">
								<!-- 删帖 -->
								<div class="flex_a color_d" @click="removeComment(item.id,index)" v-if="item.canDelete">
									<img :src='resourceDomain+"static/icon/clear-his.png"'>
									<div>删除该条评论</div>
								</div>
								<!-- 答复 -->
								<div class="color_c flex_a" v-if="item.officialStatus" @click="toCommentDetail(item.id,item.deleted)">
									<img :src='require("../../assets/img/books/reply.png")'>
									<div>点击查看回复</div>
								</div>
							</div>

						</div>
					</div>
				</van-list>
				<div class="color_e font_size_c paddinga" style="text-align:center;" v-else>
					<img :src='resourceDomain+"static/icon/no_order.png"' class="noorderimg">
					暂无数据，逛逛别的分类吧~
				</div>
			</van-pull-refresh>
		</div>
		<!-- </div> -->

	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	import {
		ImagePreview
	} from 'vant';
	export default {
		name: 'CommentList',
		components: {
			headTop: headTop
		},
		data() {
			return {
				default_avatar: "https://wenwu3.oss-cn-hangzhou.aliyuncs.com/static/default_avatar.jpg", //默认头像
				resourceDomain: api.resourceDomain,
				commentsList: [],
				page: 0,
				pages: undefined,
				isLoading: false,
				loading: false,
				finished: false,
				finishedText: "",
				// orderStatus: 1
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {

		},
		activated() {
			this.updatePage()
		},

		methods: {
			...mapActions("userModule", ["SET_OPENID"]),
			
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							window.scrollTo(0, 0);
							this.commentsList = [];
							this.page = 0;
							this.loading = true
							this.isLoading= false
							this.finished = false
							this.finishedText=''
							this.$toast.loading({
								overlay: true,
								message: '加载中...',
								duration: 0
							})
							this.getListByUserId()
						},
						
			// 预览多图
			previewImages(images, idx) {
				images.forEach((value, index) => {
					images[index] = this.resourceDomain + value
				});
				ImagePreview({
					images: images,
					startPosition: idx,
					loop: false
				});
			},
			//tab切换函数，课程和图书
			switchNav(v) {
				this.orderStatus = v;
				this.commentsList = [];
				this.page = 0;
				this.loading = true
				this.finished = false
				this.$toast.loading({
					overlay: true,
					message: '加载中...',
					duration: 0
				})
				this.getListByUserId()
			},

			// 获取图书评论列表
			getListByUserId() {
				let commentsList = this.commentsList;
				let page = this.page + 1;
				api.get("/book/comment/getListByUserId", {
					page: page,
					size: 5
				}).then((res) => {
					this.$toast.clear();
					console.log(res, "-----获取图书评论列表------");
					if (res.code == 20000) {
						if (res.data.myComments.length > 0) {
							for (var i = 0; i < res.data.myComments.length; i++) {
								commentsList.push(res.data.myComments[i]);
							}

							this.commentsList = commentsList;
							this.page = page;
							this.pages = res.data.pages;
							// 加载状态结束
							this.isLoading = false
							this.loading = false
							// 设置是否可以继续上拉加载
							if (this.page == this.pages) {
								this.finished = true
							} else {
								this.finished = false
							}
							this.finishedText = "没有更多了~"
						} else {
							this.finished = true
							this.finishedText = ""
							this.commentsList = []
						}
					} else {
						this.$toast(res.message);
					}
				});
			},

			/**下拉刷新 */
			onRefresh() {
				console.log("----")
				this.page = 0;
				this.commentsList = [];
				this.getListByUserId()
				this.isLoading = false;
			},
			/**上拉加载 */
			onLoad() {
				console.log("+++")
				if (this.page == this.pages) {
					this.$toast('没有更多咯~')
				} else {
					this.$toast.loading({
						overlay: true,
						message: "加载中...",
						duration: 0,
					});
					this.getListByUserId()
				}
			},

			// 跳转图书详情
			toBooksDetail(bookId) {
				this.$router.push({
					'path': '/book_detail',
					query: {
						bookId: bookId
					}
				})
			},

			// 删除评论
			removeComment(id, index) {
				this.$toast.loading({
					overlay: true,
					message: '删除中...',
					duration: 0
				})

				api.post(`/book/comment/removeById/${id}`, {}).then(res => {
					this.$toast.clear()
					console.log(res, "-----removeById------")
					if (res.success) {
						this.$toast.success('删除成功！');
						this.$set(this.commentsList[index], 'deleted', '2');
					} else {
						this.$toast.fail("删除失败，请刷新重试");
					}
				})
			},

			// 跳转评论详情
			toCommentDetail(id, deleted) {
				if (deleted != 0) {
					this.$toast.fail("该条评论已删除，请刷新");
					return false
				} else {
					this.$router.push({
						path: "/comment_detail",
						query: {
							id: id
						},
					});
				}
			},

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.noorderimg {
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
		display: block;
	}

	.paddinga {
		padding: 15px 0;
	}

	.main_comment {
		padding: 45px 0 15px;
	}

	.comment_list {
		width: 375px;
	}

	.comment_list_item {
		width: 345px;
		margin-bottom: 15px;
		padding: 15px;
		position: relative;
	}

	.comment_list_deleteMask {
		background-color: rgba(255, 255, 255, .6);
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 9;
	}

	.comment_list_deleteMask img {
		width: 100px;
		height: 100px;
		display: block;
	}

	.comment_item_statusIcon {
		width: 60px;
		height: 62px;
		right: 0;
		top: 0;
		position: absolute;
	}

	.comment_item_statusIcon img {
		display: block;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.top_c {
		position: fixed;
		width: 100%;
		left: 0;
		right: 0;
		top: 48px;
		z-index: 999;
		height: 45px;
		line-height: 45px;
		letter-spacing: 1px;
	}

	.comment_tab_item.active {
		color: #3b7bfd;
	}

	.comment_tab_item.active::after {
		content: '';
		width: 25px;
		height: 3px;
		background-color: #3b7bfd;
		border-radius: 1.5px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.comment_tab_item {
		position: relative;
		height: 45px;
		line-height: 45px;
	}

	.con_comment {
		padding-top: 48px;
	}

	.comment_list_userinfo {
		width: 345px;
		height: 40px;
		margin-bottom: 10px;
	}

	.comment_list_default_avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.comment_list_userright {
		width: 290px;
		height: 40px;
		flex-direction: column;
	}

	.comment_list_book {
		background-color: #f4f4f4;
		width: 325px;
		padding: 8px 10px;
		margin-bottom: 10px;
	}

	.comment_list_txt {
		letter-spacing: 1px;
		line-height: 1.4;
		white-space: pre-wrap;
	}

	.comment_list_imgs {
		width: 100%;
		flex-wrap: wrap;
		padding-top: 12px;
	}

	.comment_list_img_item {
		margin-right: 15px;
		margin-bottom: 10px;
		width: 105px;
		height: 105px;
	}

	.comment_list_img_item:nth-child(3n) {
		margin-right: 0 !important;
	}

	.comment_list_img_item img {
		width: 105px;
		height: 105px;
		display: block;
		overflow: hidden;
		object-fit: cover;
	}

	.comment_list_btns {
		padding-top: 10px;
	}

	.comment_list_btns img {
		display: block;
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}
</style>
